import Button from "components/common/Button";
import { SearchOutlined, SaveOutlined } from "@ant-design/icons";
import Input from "components/common/Input";
import Colors from "assets/Colors";

import { useTranslation } from "react-i18next";
import CustomSelector from "components/common/Selector";
import EuroIcon from "components/icons/EuroIcon";
import { Col, Row } from "antd";
import useWindowSize from "useWindowSize";
import { useState } from "react";
import s from "../../../styles/TopMenu.styles";

function TopMenu({
  changeSearchValue,
  searchValue,
  addNewElement,
  view,
  setView,
  editing,
  setEditing,
  loading,
  priceListsOptions,
  selectList,
  setSelectList,
  selectCategory,
  setSelectCategory,
  selectSubcategory,
  setSelectSubcategory,
  handleUpdatePriceList,
  categoriesListOptions,
  subCategoriesListOptions,
  hasEdits,
  saving,
}) {
  const { t } = useTranslation();

  const { width } = useWindowSize();

  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <s.Container
      style={{
        justifyContent: "space-between",
        flexWrap: "wrap",
      }}
    >
      <Row
        style={{
          width: "100%",
        }}
      >
        <Col
          xs={24}
          // sm={16}
          md={24}
          lg={14}
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <s.Title>
            {t("containers.InventoryPriceList.TopMenu.quickEdit")}
          </s.Title>
          <Row gutter={[10, 10]}>
            <Col
              xs={24}
              // sm={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CustomSelector
                disabled={loading || view === "lists"}
                placeholder={t(
                  "containers.InventoryPriceList.TopMenu.selectList"
                )}
                style={{ width: "100%", borderRadius: "2px" }}
                options={priceListsOptions}
                value={selectList}
                onChange={(value) => {
                  setSelectList(value);
                  setSelectCategory(null);
                  setSelectSubcategory(null);
                }}
              />
            </Col>
            <Col
              xs={24}
              // sm={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CustomSelector
                disabled={loading || view === "lists"}
                placeholder={t(
                  "containers.InventoryPriceList.TopMenu.category"
                )}
                style={{ width: "100%", borderRadius: "2px" }}
                options={categoriesListOptions}
                value={selectCategory}
                onChange={(value) => {
                  setSelectCategory(value);
                  setSelectSubcategory(null);
                }}
              />
            </Col>
            <Col
              xs={24}
              // sm={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              <CustomSelector
                disabled={
                  loading ||
                  view === "lists" ||
                  subCategoriesListOptions.length <= 1
                }
                placeholder={t(
                  "containers.InventoryPriceList.TopMenu.subCategory"
                )}
                style={{ width: "100%", borderRadius: "2px" }}
                options={subCategoriesListOptions}
                value={selectSubcategory}
                onChange={(value) => setSelectSubcategory(value)}
              />
            </Col>
            <Col
              xs={24}
              // sm={12}
              md={6}
              style={{
                display: "flex",
                flexDirection: "row",
              }}
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
            >
              {isHovered || searchValue.length > 0 ? (
                <Input
                  disabled={loading}
                  placeholder={t("components.InventoryItems.TopMenu.search")}
                  style={{
                    marginBottom: "7px",
                    maxWidth: "350px",
                    borderRadius: "2px",
                  }}
                  onChange={(e) => changeSearchValue(e.target.value)}
                />
              ) : (
                <Button
                  disabled={loading}
                  style={{
                    width: "40px",
                    height: "40px",
                    border: `1px solid ${Colors.background_dividers}`,
                    marginBottom: "10px",
                  }}
                  icon={<SearchOutlined />}
                />
              )}
            </Col>
          </Row>
        </Col>

        <Col
          xs={24}
          // sm={16}
          md={24}
          lg={10}
          gutter={[10, 10]}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: "10px",
            ...(width <= 990 && {
              justifyContent: "flex-start",
            }),
          }}
        >
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {width > 768 && <s.Title>&nbsp; </s.Title>}
            <div
              style={{
                display: "flex",
                height: "40px",
                alignItems: "center",
                justifyContent: "space-between",
                borderRadius: "2px",
                border: `1px solid ${Colors.background_dividers}`,
                overflow: "hidden",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0 10px",
                  background: view == "prices" ? Colors.primary : "white",
                  color: view == "prices" ? Colors.text_on_secondary : "black",
                  height: "100%",
                  cursor: "pointer",
                  minWidth: "100px",
                  width: "100%",
                  justifyContent: "center",
                  pointerEvents: loading ? "none" : "auto",
                }}
                onClick={() => setView("prices")}
              >
                {t("containers.InventoryPriceList.TopMenu.viewPrices")}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "0 10px",
                  height: "100%",
                  background: view == "lists" ? Colors.primary : "white",
                  color: view == "lists" ? Colors.text_on_secondary : "black",
                  minWidth: "100px",
                  width: "100%",
                  justifyContent: "center",
                  cursor: loading || editing ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  if (!editing) {
                    setView("lists");
                  }
                }}
              >
                {t("containers.InventoryPriceList.TopMenu.viewList")}
              </div>
            </div>
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {width > 768 && <s.Title>&nbsp; </s.Title>}
            <Button
              disabled={view == "lists" || loading}
              loading={saving}
              style={{
                width: "40px",
                height: "40px",
                border: `1px solid ${Colors.background_dividers}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: editing && !saving ? Colors.primary : "white",
              }}
              onClick={() => {
                if (editing) {
                  if (hasEdits) {
                    handleUpdatePriceList();
                  } else {
                    setEditing(!editing);
                  }
                } else {
                  setEditing(!editing);
                }
              }}
              icon={
                editing ? (
                  <SaveOutlined
                    style={{
                      fontSize: "19px",
                      color: Colors.text_on_secondary,
                    }}
                  />
                ) : (
                  <EuroIcon size="18px" />
                )
              }
            />
          </Col>
          <Col
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {width > 768 && <s.Title>&nbsp; </s.Title>}
            <Button
              disabled={loading}
              type="primary"
              style={{
                background: Colors.primary,
                color: Colors.text_on_secondary,
                width: "none",
                fontWeight: "500",
                border: "none",
                height: "40px",
                marginBottom: "7px",
              }}
              onClick={() => addNewElement()}
            >
              {t("containers.InventoryPriceList.TopMenu.newList")}
            </Button>
          </Col>
        </Col>
      </Row>
    </s.Container>
  );
}

export default TopMenu;
